import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export default function OrdernummerKiezer({ value, onChange, afdelingId }) {
  const [lijst, setLijst] = useState([]);
  const [open, setOpen] = useState(false);
  const [oms, setOms] = useState('');
  const [bezig, setBezig] = useState(false);

  const laden = useCallback(() => {
    const q = afdelingId ? `?afdeling_id=${afdelingId}` : '';
    api.get(`/ordernummers${q}`)
      .then(r => setLijst(r.data.ordernummers || []))
      .catch(() => setLijst([]));
  }, [afdelingId]);
  useEffect(() => { laden(); }, [laden]);

  const v = (value || '').trim();
  const match = lijst.find(o => o.nummer === v);
  const z = v.toLowerCase();
  const gefilterd = (match || !z) ? lijst : lijst.filter(o =>
    o.nummer.toLowerCase().includes(z) ||
    (o.omschrijving || '').toLowerCase().includes(z) ||
    (o.laatste_titel || '').toLowerCase().includes(z));

  const opslaan = async () => {
    if (!v || bezig) return;
    setBezig(true);
    try {
      await api.post('/ordernummers', { nummer: v, omschrijving: oms, afdeling_id: afdelingId || undefined });
      setOms('');
      laden();
    } catch (e) {
      alert(e?.response?.data?.message || 'Opslaan mislukt');
    }
    setBezig(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <input type="text" value={value || ''} autoComplete="off"
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder="Zoek op omschrijving of nummer" />
      {open && gefilterd.length > 0 && (
        <div style={{ position: 'absolute', left: 0, right: 0, top: '100%', zIndex: 50, maxHeight: 260, overflowY: 'auto',
          background: '#fff', color: '#222', border: '1px solid #ccc', borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,.15)' }}>
          {gefilterd.map(o => (
            <div key={o.id} onMouseDown={(e) => { e.preventDefault(); onChange(o.nummer); setOpen(false); }}
              style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '8px 10px', cursor: 'pointer',
                borderBottom: '1px solid #eee', background: o.nummer === v ? '#eef4ff' : '#fff' }}>
              <span style={{ fontWeight: o.omschrijving ? 600 : 400, fontStyle: o.omschrijving ? 'normal' : 'italic',
                color: o.omschrijving ? '#222' : '#888', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {o.omschrijving || o.laatste_titel || 'geen omschrijving'}
              </span>
              <span style={{ color: '#555', fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>{o.nummer}</span>
            </div>
          ))}
        </div>
      )}
      <a href="/ordernummers" target="_blank" rel="noreferrer" style={{ float: 'right', fontSize: 12, marginTop: 4 }}>Lijst beheren</a>
      {match && (match.omschrijving || match.laatste_titel) && (
        <small style={{ display: 'block', marginTop: 4, opacity: 0.75 }}>{match.omschrijving || ('Laatst gebruikt voor: ' + match.laatste_titel)}</small>
      )}
      {v && (!match || !match.omschrijving) && (
        <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
          <input type="text" value={oms} onChange={(e) => setOms(e.target.value)} style={{ flex: 1 }} maxLength={60}
            placeholder={match ? 'Korte omschrijving toevoegen' : 'Nieuw nummer: korte omschrijving'} />
          <button type="button" onClick={opslaan} disabled={bezig}>Bewaar</button>
        </div>
      )}
    </div>
  );
}
